/* =========================================================
   Sportsndeco.com — Moteur "TALE OF THE TAPE" (fiche du combattant).
   Affiche data pour sports de combat : nom + surnom + record + fiche technique.
   API : SNCombatTale.render(data, opts) -> string SVG
     data : { name, nickname, discipline, record, category, height, reach,
              stance, ko, age, gym, years }
     opts : { palette }
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 66;
  const PALETTES = {
    nuit:  { label:'Nuit',  bg:'#0B1B33', ink:'#ffffff', muted:'#8FA1B8', accent:'#FF6B2C', gold:'#E8B04B', line:'#24374f', chip:'#12294a' },
    noir:  { label:'Noir',  bg:'#111418', ink:'#ffffff', muted:'#8A8F98', accent:'#FF6B2C', gold:'#E8B04B', line:'#2A2E35', chip:'#1B1F25' },
    ring:  { label:'Ring',  bg:'#1A0E10', ink:'#ffffff', muted:'#B79097', accent:'#FF4D3D', gold:'#E8B04B', line:'#3A2427', chip:'#241416' },
    craie: { label:'Craie', bg:'#F5F2EB', ink:'#14243B', muted:'#7A8699', accent:'#FF6B2C', gold:'#B8862B', line:'#E1DBD0', chip:'#EDE8DE' },
  };
  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.nuit;
    const cx = PW / 2;
    const name = (data.name || 'VOTRE NOM').toUpperCase();
    const nameSize = name.length > 14 ? 46 : name.length > 10 ? 54 : 62;

    // Fiche technique : uniquement les lignes renseignées
    const rows = [
      ['CATÉGORIE', data.category],
      ['TAILLE', data.height],
      ['ALLONGE', data.reach],
      ['GARDE', data.stance],
      ['KO / SOUMISSIONS', data.ko],
      ['ÂGE', data.age],
    ].filter(r => String(r[1] || '').trim());

    const rowsSvg = rows.map((r, i) => {
      const y = 636 + i * 52;
      return `<text x="${MX}" y="${y}" font-size="13" font-weight="600" fill="${p.muted}" letter-spacing="1.5">${esc(r[0])}</text>`
        + `<text x="${PW - MX}" y="${y}" font-size="21" font-weight="800" fill="${p.ink}" text-anchor="end">${esc(r[1])}</text>`
        + (i < rows.length - 1 ? `<line x1="${MX}" y1="${y + 20}" x2="${PW - MX}" y2="${y + 20}" stroke="${p.line}" stroke-width="1"/>` : '');
    }).join('');

    const footY = 636 + rows.length * 52 + 34;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<rect x="20" y="20" width="${PW - 40}" height="${PH - 40}" fill="none" stroke="${p.line}" stroke-width="1.5" rx="3"/>
<text x="${cx}" y="128" font-size="14" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">TALE OF THE TAPE</text>
<text x="${cx}" y="${196}" font-size="${nameSize}" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="-1.5">${esc(name)}</text>
${ data.nickname ? `<text x="${cx}" y="240" font-size="22" font-weight="600" fill="${p.gold}" text-anchor="middle" letter-spacing="0.5">« ${esc(String(data.nickname).toUpperCase())} »</text>` : '' }
${ data.discipline ? `<text x="${cx}" y="${data.nickname ? 276 : 250}" font-size="14" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="3">${esc(String(data.discipline).toUpperCase())}</text>` : '' }
<line x1="${MX}" y1="320" x2="${PW - MX}" y2="320" stroke="${p.line}" stroke-width="1.5"/>
<text x="${cx}" y="470" font-size="120" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="-3">${esc(data.record || '0-0-0')}</text>
<text x="${cx}" y="512" font-size="14" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="5">VICTOIRES · DÉFAITES · NULS</text>
<line x1="${MX}" y1="566" x2="${PW - MX}" y2="566" stroke="${p.line}" stroke-width="1.5"/>
${rowsSvg}
<line x1="${MX}" y1="${footY - 30}" x2="${PW - MX}" y2="${footY - 30}" stroke="${p.line}" stroke-width="1.5"/>
${ data.gym ? `<text x="${cx}" y="${footY}" font-size="22" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="1">${esc(String(data.gym).toUpperCase())}</text>` : '' }
${ data.years ? `<text x="${cx}" y="${footY + 28}" font-size="13" font-weight="600" fill="${p.accent}" text-anchor="middle" letter-spacing="3">${esc(String(data.years).toUpperCase())}</text>` : '' }
</svg>`;
  }

  window.SNCombatTale = { render, PALETTES };
})();
